function getQueryParameter(name) {
	const urlParams = new URLSearchParams(window.location.search)

	return urlParams.get(name)
}

document.addEventListener('DOMContentLoaded', () => {
	const deadlineFromURL = getQueryParameter('deadline')

	if (deadlineFromURL) {
		const productLinks = document.querySelectorAll('.product-card-wrapper .full-unstyled-link')

		for (const link of productLinks) {
			const linkURL = new URL(link.href)

			linkURL.searchParams.append('deadline', deadlineFromURL)

			link.href = linkURL.toString()
		}
	}
})